import React from 'react';

import { Inline, Stack } from '@atlaskit/primitives/compiled';

import { useChildren } from '../../hooks/useChildren.tsx';
import type { A2UIComponentDefinition } from '../../types/A2UIComponents.types.tsx';
import type { A2UIListProps } from '../../types/A2UIComponents.types.tsx';

type Props = {
	definition: A2UIComponentDefinition;
	visited?: Set<string>;
};

export const A2UIList = ({ definition, visited }: Props): React.JSX.Element => {
	const def = definition as A2UIListProps;
	const children = useChildren(def.children, visited);

	const direction = def.direction ?? 'vertical';
	const align = def.align as 'start' | 'center' | 'end' | 'stretch' | undefined;

	if (direction === 'horizontal') {
		return (
			<Inline space="space.200" alignBlock={align}>
				{children}
			</Inline>
		);
	}

	return (
		<Stack space="space.200" alignInline={align ?? 'stretch'}>
			{children}
		</Stack>
	);
};
